import React, { createContext, useContext, useEffect, useMemo } from "react";
import { useLocalStorage } from "react-admin-base";
const ThemeContext = createContext(null);
const AllThemesContext = createContext(null);
export function useTheme() {
    return useContext(ThemeContext);
}
export function useAllThemes() {
    return useContext(AllThemesContext);
}
export default function ThemeProvider({ themes, defaultTheme, children }) {
    const state = useLocalStorage('theme');
    const [theme, setTheme] = state;
    const rTheme = theme || defaultTheme || 'light';
    useEffect(function () {
        const promise = (themes[rTheme] || themes[defaultTheme]).css()
            .then(css => {
            css.default.use();
            return css;
        });
        return function () {
            promise.then(css => css.default.unuse());
        };
    }, [theme]);
    const val = useMemo(() => [rTheme, setTheme], [rTheme, setTheme]);
    return React.createElement(AllThemesContext.Provider, { value: themes },
        React.createElement(ThemeContext.Provider, { value: val }, children));
}
